import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import { Link } from "react-router";
import ForgotPasswordActions from "../../../Action/Actions/ForgotPasswordActions";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import Button from '@material-ui/core/Button';

class ForgotPassword extends Component {
  constructor(public props) {
    super(props);
    this.process = this.process.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  /**
   * This is the hotfix for react-router issue, that cause the problem of
   * infinite rerendering of component: routeParams(received for react-router Route) props
   * updates few times per sec
   * 
   * TODO: Should be fixed by installing the new version of react-router-dom
   * */ 
   shouldComponentUpdate(newProps, nextState) {
    if (this.state !== nextState) return true;
    const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
    if (
      isPropsStringsSame
      && newProps.routeParams !== this.props.routeParams
    ) {
      return false;
    }

    return !isPropsStringsSame;
  }

  protected process() {
    this.props.dispatch(ForgotPasswordActions.request(this.props.app.session.user));
  }

  protected closePopup() {
    this.props.dispatch(ForgotPasswordActions.closePopup());
  }

  public render() {
    return (
      <div className="state-auth">
        <div className="box component-forgot-password">
          <div style={{textAlign: "center"}}>
            <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
              {this.trans("title-reset-password")}
            </div>
            
            <div className="info-text-gray">
              {this.trans("title-reset-password-notice")}
            </div>
          </div>

          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={this.process}
            style={{margin: "20px 0"}}
          >
            {this.trans("title-send-me-instructions")}
          </Button>

          <Link to="/auth/check-email">
            {this.trans("link-back-to-signin")}
          </Link>

          <PromptDialog
            {...this.props}
            content={this.props.forgotPassword.popupMessage}
            openLeavePrompt={this.props.forgotPassword.popup}
            onlyPositiveButton={true}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={false}
            actions={[
              <Button
                variant="contained"
                color="primary"
                onClick={this.closePopup}
              >
                {this.trans("button-close")}
              </Button>
            ]}
            hideCross={true}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    forgotPassword: state.forgotPassword,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ForgotPassword
);
